import { ReactNode, createContext } from "react";
import useFormaPagamento, { CreateFormaPagamentoType, FormaPagamentoType, UpdateFormaPagamentoType} from "./hooks/useFormaPagamento";

interface FormaPagamentoContextProviderProps {
    children: ReactNode;
}

export interface FormaPagamentoContextData {
    getAllFormaPagamentoPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<FormaPagamentoType[] | null>;
    setFormaPagamento: any;
    formaPagamento: FormaPagamentoType;
    setListFormaPagamento: any;
    listFormaPagamento: FormaPagamentoType[];
    setInitialListFormaPagamento: any;
    initialListFormaPagamento: FormaPagamentoType[];
    setFormaPagamentoPageCount: any;
    formaPagamentoPageCount: number;
    createFormaPagamento: (createFormaPagamentoType: CreateFormaPagamentoType) => Promise<CreateFormaPagamentoType | null>;
    updateFormaPagamento: (updateFormaPagamentoType: UpdateFormaPagamentoType) => Promise<UpdateFormaPagamentoType | null>;
    deleteFormaPagamento: (id: number) => Promise<FormaPagamentoType | null>;
    handleGetFormaPagamentoByEmpresaId: (empresaId: number) => Promise<FormaPagamentoType[] | null>;
    listFormaPagamentoByEmpresa: FormaPagamentoType[];
    setListFormaPagamentoByEmpresa: any;
}

const initialState: FormaPagamentoContextData = {
    getAllFormaPagamentoPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setFormaPagamento: () => { },
    formaPagamento: {
        id: 0,
        name: "",
        linkGateway: "",
        token: "",
    },
    setListFormaPagamento: () => { },
    listFormaPagamento: [],
    setInitialListFormaPagamento: () => { },
    initialListFormaPagamento: [],
    setFormaPagamentoPageCount: () => { },
    formaPagamentoPageCount: 0,
    createFormaPagamento: async (createFormaPagamentoType: CreateFormaPagamentoType) => {
        return Promise.resolve(null);
    },
    updateFormaPagamento: async (updateFormaPagamentoType: UpdateFormaPagamentoType) => {
        return Promise.resolve(null);
    },
    deleteFormaPagamento: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetFormaPagamentoByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listFormaPagamentoByEmpresa: [],
    setListFormaPagamentoByEmpresa: () => { },
};

export const FormaPagamentoContext =
    createContext<FormaPagamentoContextData>(initialState);

export default function FormaPagamentoContextProvider({
    children,
}: FormaPagamentoContextProviderProps) {
    const {
        getAllFormaPagamentoPaged,
        createFormaPagamento,
        updateFormaPagamento,
        deleteFormaPagamento,
        formaPagamento,
        setFormaPagamento,
        setListFormaPagamento,
        listFormaPagamento,
        initialListFormaPagamento,
        setInitialListFormaPagamento,
        setFormaPagamentoPageCount,
        formaPagamentoPageCount,
        handleGetFormaPagamentoByEmpresaId,
        listFormaPagamentoByEmpresa,
        setListFormaPagamentoByEmpresa,
    } = useFormaPagamento();

    return (
        <FormaPagamentoContext.Provider
            value={{
                getAllFormaPagamentoPaged,
                createFormaPagamento,
                updateFormaPagamento,
                deleteFormaPagamento,
                formaPagamento,
                setFormaPagamento,
                setListFormaPagamento,
                listFormaPagamento,
                initialListFormaPagamento,
                setInitialListFormaPagamento,
                setFormaPagamentoPageCount,
                formaPagamentoPageCount,
                handleGetFormaPagamentoByEmpresaId,
                listFormaPagamentoByEmpresa,
                setListFormaPagamentoByEmpresa,
            }}
        >
            {children}
        </FormaPagamentoContext.Provider>
    );
}